import { InputDisable, BackNextButton } from "../../../../../common";
import { useSelector, useDispatch } from "react-redux";

import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";
import { ReactComponent as DragIcon } from "../../../../../../assets/icons/dragLine.svg";



import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { useEffect } from "react";
import { useState } from "react";
import { useUpdateClaimDraftMutation } from "../../../../../../store/Company/companyApiSlice";
import { CommonToast } from "../../../../../common/Toast";
import { processIndustryData } from "../../../../../../utils/Helper";

// const initialUsers = [
//   { id: 'sb1', seq: 1, name: 'user1' },
//   { id: 'sb2', seq: 2, name: 'user2' },
//   { id: 'sb3', seq: 3, name: 'user3' },
// ]

const SortableItem = ({ user }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: user.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    padding: '10px',
    // margin: '16px 0',
    background: '#E8E8E8',
    border: '1px solid #9FA4A4',
    color:'#777F7F',
    borderRadius: '4px',
    textAlign:'left',
  }

  return (
    <li className="flex justify-between items-center my-4" ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <p>{user.sub_industry}</p>
      <DragIcon/>
    </li>
  )
}


export const Industry = ({ onPrev, onNext, onSkip }) => {
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const [users, setUsers] = useState([]);
  const [updateClaimDraft] = useUpdateClaimDraftMutation();
  const sensors = useSensors(useSensor(PointerSensor));

  useEffect(()=>{
    setUsers(currentEditingCompany?.sub_industry_data)
  },[currentEditingCompany])
  

  const handleDragEnd = (event) => {
    const { active, over } = event
    if (!over || active.id === over.id) return

    const oldIndex = users.findIndex((u) => u.id === active.id)
    const newIndex = users.findIndex((u) => u.id === over.id)

    const reordered = arrayMove(users, oldIndex, newIndex)

    const updatedUsers = reordered.map((user, index) => ({
      ...user,
      sequence: index + 1,
    }))

    setUsers(updatedUsers)
  }

  const handleUpdateData = async () => {
    try {
      const processedData = processIndustryData(users)
      const res = await updateClaimDraft({ token, url: currentEditingCompany.companyID.startsWith("TRX") ? `sub-industry/update/${currentEditingCompany.companyID}` : `claimdraft/${currentEditingCompany.draftID}/update_sub_industry`, data: processedData });
      
      if(!res.error){
        CommonToast.success("Industry updated successfully");
        onNext(2, "Address & Contact Information", "About");
      }else if(res.error){
        CommonToast.error(res.error.message || "Failed to update sequence");
      }
    } catch (error) {
      CommonToast.error(error.message || "Failed to update sub-industry")
    }
  }

  return (
    <div className="mt-5 mr-20 ">
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2 flex">
        Industries  <span className="pendingapproval">
          {

            currentEditingCompany?.industry?.status === "Verified" ? <Verified /> : currentEditingCompany?.industry?.status === "Declined" ?
              <Declined /> : currentEditingCompany?.industry?.status === "Skipped" ? <Skipped /> : currentEditingCompany?.industry?.status === "Requested" && <Requested />
          }
        </span>
      </h3>
      <div className="border border-[#EBF0F3] rounded-[8px] px-8 py-4 mb-8">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={users.map((u) => u.id)}
            strategy={verticalListSortingStrategy}
          >
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {users.map((user) => (
                <SortableItem key={user.id} user={user} />
              ))}
            </ul>
          </SortableContext>
        </DndContext>
      </div>
      <BackNextButton
        onPrev={() => onPrev(0, "About Company", "About")}
        onNext={() => handleUpdateData()}
        onSkip={() => onSkip(2, "Address & Contact Information", "About")}
        isLoading={false}
      />
    </div>
  );
};
